import React from 'react';
import { headers } from "../../../../actions";
import Card from '../../../components/card/Card';
import BasicInfoModal from './basicInfomodal';
import {Empty, Spin, Modal, Pagination, Table, Popover} from 'antd';
import prev from './images/prev.png';
import './myTopicList.scss';
import  TopicSelectionList from'../../../../components/topicSelection/topicSelectionList'
import eventProxy from "../../../../utils/eventProxy";
const STATUTS_MAP = {
    type_0: { name: "全部", className: "unget_status", value: 0 },
    type_1: { name: "草稿", className: "unget_status", value: 1 },
    type_2: { name: "已提交", className: "recieve_status", value: 2 },
    type_3: { name: "已撤回", className: "unget_status", value: 3 },
    type_4: { name: "留用", className: "publish_status", value: 4 },
    type_5: { name: "已弃用", className: "publish_status", value: 5 },
    type_6: { name: "已采用", className: "publish_status", value: 6 },
    type_7: { name: "转为任务", className: "recieve_status", value: 7 },
    type_8: { name: "已指派", className: "recieve_status", value: 8 },
};

class MyTopicList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            current: {},
            loading: true,
            visible:false,

        }
    }

    componentDidMount() {
        getTopicList((res) => {
            let resultList = [];
            if (res.code === 0) {
               
                if (res.count > 5) {
                    resultList = res.data.slice(0, 5)
                } else {
                    resultList = res.data
                }
               
            }
            if(resultList.length>0){
                this.setState({
                    list: resultList,
                    loading: false
                })
            }else{
                this.setState({
                    list: [],
                    loading: false
                })
            }
        })
    }

    formateStatus(value) {
        if (STATUTS_MAP["type_" + value]) {
            return <div className={STATUTS_MAP["type_" + value].className}>{STATUTS_MAP["type_" + value].name}</div>
        }
        return <div></div>
    }

    render() {
        const { list, currentItem, loading } = this.state;
        return (
            <Card title="我的选题" style={{ marginTop: 20 }} showMore={true} moreClick={()=>this.moreClick()}>
                <div className="desktop-topic-list">
                    {
                        loading ? <div className="center"><Spin /></div> : (
                            list&&list.length === 0 ? <div className="center"><Empty /></div> :
                            <div className="desktop-topic-list-content">
                                {
                                   list.map((item, index) => (
                                        <div className="item" key={item.id} onClick={() => { this.setState({ currentItem: item }); this.basicInfo.changeVisible(true) }}>
                                            <div className="column-1">
                                                <img src={prev} alt="" />
                                            </div>
                                            <div className="column-2">
                                                <span>{item.tsName}</span>
                                                <span>{item.tsContent}</span>
                                            </div>
                                            <div className="column-3">
                                                {this.formateStatus(item.tsStatus)}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        )
                    }
                </div>
                <BasicInfoModal ref={(ref) => this.basicInfo = ref} data={currentItem} />

                <Modal
                    title="选题列表"
                    visible={this.state.visible}
                    onOk={()=>{}}
                    onCancel={()=>this.setState({visible:false})}
                    width={1300}
                    footer={null}
                    bodyStyle={{paddingTop:0,paddingBottom:0}}
                >
                    <div style={{maxHeight:750,width:1250}}>
                        <TopicSelectionList hideHead={true}/>
                    </div>
                </Modal>

            </Card>
        )
    }

    //点击更多
    moreClick(){
        this.setState({visible:true})
    }

}

export const getTopicList = (callBack) => {
    let url = `/cm-sites-pms/topicSelection/list?start=1&size=5&queryStr=&tsListStatus=1&tsStatus=0&tsDirection=0&time=${new Date().getTime()}`;
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMyInterView", error);
        callBack("");
    })
};

export default MyTopicList